<template>
  <div>
    <div class="member-main-tab" v-if="!weekChange">
      <ul class="main-tab">
        <li class="active">绑定手机</li>
      </ul>
    </div>

    <div class="member-main-body" :class="weekChange&&'login-bind'">
      <div class="bind-title">{{weekChange?'绑定手机号':'修改手机号'}}</div>
      <div class="bind-form">
        <Form :model="bindData" :label-width="80">
          <FormItem label="手机号">
            <Input
              size="large"
              v-model="bindData.cellphone"
              placeholder="请输入手机号"
            />
          </FormItem>
          <FormItem label="验证码">
            <Input
              v-model="bindData.phoneCode"
              size="large"
              placeholder="请输入验证码"
              style="position: relative; width: 170px; z-index: 1"
            />
            <Button
              type="warning"
              size="large"
              style="
                position: relative;
                margin-left: -10px;
                width: 120px;
                z-index: 2;
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;
              "
              @click="getPhoneCode"
              >{{ phoneCodeText }}</Button
            >
          </FormItem>
          <FormItem>
            <Button
              type="primary"
              size="large"
              shape="circle"
              @click="bindPhone"
              long
              >确定绑定</Button
            >
          </FormItem>
        </Form>
      </div>
    </div>
  </div>
</template>
<script>
import { siteMixin } from "../../utils/mixin";
import { account } from "../../request";
export default {
  mixins: [siteMixin],
  data() {
    return {
      bindData: {
        cellphone: "",
        phoneCode: "",
      },
      phoneCodeText: "获取验证码",
      weekChange: false
    };
  },
  mounted(){
    if(localStorage.getItem('weekPassChange')==='none'){
      this.weekChange = true;
    }
  },
  methods: {
    getPhoneCode() {
      if (!this.isRequest) {
        if (!this.bindData.cellphone) {
          this.$Message.error("请填写手机号");
          return;
        }
        this.isRequest = true;
        account
          .getPhoneCode(this.bindData.cellphone, this.loginUser.userId)
          .then((result) => {
            if (result.status == 1) {
              let second = 60;
              let timer = setInterval(() => {
                second--;
                this.phoneCodeText = `还剩 ${second} 秒`;
                if (second === 0) {
                  this.phoneCodeText = "重新获取";
                  this.isRequest = false;
                  clearInterval(timer);
                }
              }, 1000);
            } else {
              this.$Message.error(result.message);
            }
          });
      }
    },
    bindPhone() {
      if (!this.bindData.cellphone) {
        this.$Message.error("请填写手机号");
        return;
      }
      if (!this.bindData.phoneCode) {
        this.$Message.error("请填写验证码");
        return;
      }
      account
        .bindCellphone(
          this.loginUser.userId,
          this.bindData.cellphone,
          this.bindData.phoneCode
        )
        .then((res) => {
          console.log(res);
          if (res.status === 1) {
            this.$Message.success("手机号绑定成功");
            this.loginUser.mobile = this.bindData.cellphone;
            setTimeout(() => {
              if(localStorage.getItem('weekPassChange')==='none'){
                this.$router.push({
                  path:'/forget',
                  query:{weekPass:true}
                });
                return;
              }
              this.$router.push({ name: "Account" });
            }, 2000);
          } else {
            this.$Message.error(res.message);
          }
        });
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../assets/css/var";
@import "../../assets/css/member-main.less";
.member-main-body {
  position: relative;
  padding: 30px;
}
.bind-title {
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 20px;
}
.bind-form {
  width: 360px;
}
.login-bind{
  min-height: 0 !important;
  box-shadow: none;
}
</style>